import React from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Email as EmailIcon,
  Speed as SpeedIcon,
  Security as SecurityIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import EmailSystemTest from '../components/EmailSystemTest';

const ComingSoon: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          🚀 Coming Soon
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Exciting new features are in development for SubLime
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<DashboardIcon />}
          onClick={() => navigate('/dashboard')}
          sx={{ mt: 2 }}
        >
          Back to Dashboard
        </Button>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <EmailIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                <Typography variant="h5">Email System Testing</Typography>
              </Box>
              <Typography variant="body1" paragraph>
                Test and compare SendGrid vs Nodemailer email delivery performance, speed, and spam folder placement.
              </Typography>
              <CardActions>
                <Button 
                  size="small" 
                  onClick={() => document.getElementById('email-test')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Test Email Systems
                </Button>
              </CardActions>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SpeedIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                <Typography variant="h5">Performance Analytics</Typography>
              </Box>
              <Typography variant="body1" paragraph>
                Advanced analytics and insights to help you optimize your subscription management.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <SecurityIcon sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
                <Typography variant="h5">Enhanced Security</Typography>
              </Box>
              <Typography variant="body1" paragraph>
                Additional security features and two-factor authentication for your account.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Email System Testing Section */}
      <Box id="email-test" sx={{ mt: 6 }}>
        <EmailSystemTest />
      </Box>
    </Container>
  );
};

export default ComingSoon; 